import DepsService from 'services/dependencies';
import capitalizeWords from 'utils/capitalize-words';

const CONTEXT = 'subordinateList';

export const transformData = (content) =>
  content.map((retailer) => {
    const { displayNumber, businessName, storeNumber, street1, city, state, retailerType, zipCode, id, corporateAccountRegionCode } =
      retailer;

    return {
      displayNumber,
      storeNumber,
      state,
      retailerType,
      zipCode,
      id,
      corporateAccountRegionCode,
      city: capitalizeWords(city),
      businessName: capitalizeWords(businessName),
      street1: capitalizeWords(street1),
    };
  });

const fetchSubordinateList = async ({ retailerId, ...queryParams }) => {
  const { url } = DepsService.rest.inventory.subordinates.list;
  const urlParams = { retailerId };

  const { content, ...pagination } = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  return {
    content: transformData(content),
    ...pagination,
  };
};

export default {
  fetchSubordinateList,
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/resources/subordinate-list.api.js